<template>
  <el-form
    ref="formRef"
    require-asterisk-position="right"
    label-position="top"
    :model="form"
    :rules="formRules"
  >
    <div class="info-card-title">
      签署方（{{ form.actorList.length }}/4）
    </div>
    <div v-for="(actor,index) in form.actorList" :key="actor.key">
      <div class="title">
        <div>签署方{{ index+1 }}</div>
        <el-link v-if="index!=0" type="danger" :underline="false" @click="removeDomain(actor)">
          删除
        </el-link>
      </div>
      <div class="flex px-4">
        <div class="oa-form-left">
          <el-form-item
            label="选择端口" 
            :rules="{
              required: true, message: '端口不能为空', trigger: 'blur'
            }"
            :prop="'actorList.'+index+'.platformStr'"
          >
            <el-select
              v-model="form.actorList[index].platformStr"
              filterable
              clearable
              placeholder="请选择"
              @change="handleChange($event,index)"
            >
              <el-option
                v-for="item in platFormOption"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="oa-form-right">
          <el-form-item
            label="选择企业"
            :rules="{
              required: true, message: '企业不能为空', trigger: 'blur'
            }"
            :prop="'actorList.'+index+'.actorName'"
          >
            <el-select
              v-model="form.actorList[index].actorName"
              filterable
              clearable
              :disabled="!form.actorList[index].platform"
              placeholder="请选择"
              :filter-method="(query,option)=>{
                filterOption(query,option,index)
              }"
              @change="handleChangeActorName($event,index)"
            >
              <el-option
                v-for="item in filterOptionsList[index]"
                :key="item.actorName"
                :label="item.actorName"
                :value="item.actorName"
              >
                {{ item.actorName }}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div v-if="form.actorList.length<4" class="title !justify-center title-button" @click="addDomain">
      <svg-icon icon="tabler:plus" class="text-sm" />添加签署方
    </div>
  </el-form>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { SvgIcon } from '@vue3/components';
import { queryContractCreateDropDownActor } from '../../../../..';
import { ElMessage } from 'element-plus';
import { platFormOption, IContractActorDTO, EPlatform } from '../../../../../types/contracts/contracts';

defineProps({
  enableEnterKey: {
    type: Boolean,
    default: true,
  },
  /** 自动滚动到错误位置 */
  autoScrollToError: {
    type: Boolean,
    default: true,
  },
});

const form = ref({ actorList: [{ key: Date.now() }, { key: Date.now() }] as IContractActorDTO[] });
const formRef = ref();
const optionsList = ref([]);
const filterOptionsList = ref([]);

const formRules = {
  contractSubject: [
    {
      required: true,
      message: '请输入合同主题',
      trigger: 'blur',
    },
  ],
  dateRange: [
    {
      required: true,
      message: '请选择合同到期日期',
      trigger: 'blur',
    },
  ],
};

function filterOption(query, _, index) {
  if (query) {
    filterOptionsList.value[index] = optionsList.value[index].filter((item) => {
      return item.actorName.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    });
  } else {
    filterOptionsList.value[index] = optionsList.value[index];

  }
}

function removeDomain(item) {
  var index = form.value.actorList.indexOf(item);

  if (index !== -1) {
    form.value.actorList.splice(index, 1);
  }
}
function addDomain() {
  form.value.actorList.push({ key: Date.now() } as IContractActorDTO);
}

async function handleChange(value, index) {
  const option = platFormOption.filter((item) => item.label == value);

  form.value.actorList[index].platform = option[0].platForm as EPlatform;
  form.value.actorList[index].actorType = option[0].actorType;
  form.value.actorList[index].actorName = '';

  try {
    const res = await queryContractCreateDropDownActor({
      actorType: option[0].actorType,
      platform: option[0].platForm,
    });

    optionsList.value[index] = res;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function handleChangeActorName(value, index) {
  const option = optionsList.value[index].filter((item) => item.actorName == value);

  form.value.actorList[index].platformId = option[0].platformId;
}

async function validate(callback?: () => void) {
  let valid = false;

  if (!formRef.value) return valid;

  await formRef.value.validate((v) => {
    if (v) {
      valid = true;
      callback && callback();
    }
  });

  return valid;
}

function resetFormValues() {

  formRef.value?.resetFields?.();
}

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => form.value,
  /** 表单数据重置（base props.data） */
  reset: resetFormValues,
});

</script>

<style lang="scss" scoped>
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1010px;
  height: 48px;
  background: #F5F6FA;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #EBEEF5;
  line-height: 48px;
  padding-left: 16px;
  padding-right: 16px;
  font-weight: 500;
  font-size: 14px;
  color: #262626;
  margin-bottom: 24px;
}
.title-button{
  color: #1777FF;
}
.oa-form-left {
  width: 432px;
}

.oa-form-right {
  width: 432px;
  margin-left: 114px;
}

.label {
  position: relative;

  & .tip {
    position: absolute;
    top: -30px;
    left: 85px;

  }
}

</style>
